import ModalContainer from 'components/modal/modal-container'
import ModalActions from 'components/modal/modal-actions'
import { Button, FormControlLabel, Checkbox, Stack } from '@mui/material'
import { closeModal } from 'actions/app'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import { TEST_IDS } from 'test-ids'

export interface DownloadUbjOptions {
  include_shp: boolean
  include_json: boolean
  include_logs: boolean
}

interface DownloadUbjOptionsProps {
  onConfirm: (options: DownloadUbjOptions) => void
}

export default function DownloadUbjOptions({
  onConfirm,
}: DownloadUbjOptionsProps) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [includeShp, setIncludeShp] = useState<boolean>(true)
  const [includeJson, setIncludeJson] = useState<boolean>(false)
  const [includeLogs, setIncludeLogs] = useState<boolean>(false)

  const handleCancel = useCallback(() => {
    dispatch(closeModal())
  }, [dispatch])

  const handleConfirm = useCallback(() => {
    dispatch(closeModal())
    onConfirm({
      include_shp: includeShp,
      include_json: includeJson,
      include_logs: includeLogs,
    })
  }, [includeShp, includeJson, includeLogs, onConfirm, dispatch])

  return (
    <ModalContainer data-testid={TEST_IDS.downloadUbjDialog}>
      <Stack spacing={2} sx={{ py: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={true}
              disabled={true}
              size="small"
              sx={{ padding: '0 4px' }}
            />
          }
          label="UBJ"
        />

        <FormControlLabel
          control={
            <Checkbox
              data-testid={TEST_IDS.downloadUbjCheckboxShp}
              checked={includeShp}
              onChange={(e) => setIncludeShp(e.target.checked)}
              size="small"
              sx={{ padding: '0 4px' }}
            />
          }
          label={t('download_ubj_include_shp')}
        />

        <FormControlLabel
          control={
            <Checkbox
              data-testid={TEST_IDS.downloadUbjCheckboxJson}
              checked={includeJson}
              onChange={(e) => setIncludeJson(e.target.checked)}
              size="small"
              sx={{ padding: '0 4px' }}
            />
          }
          label={t('download_ubj_include_json')}
        />

        <FormControlLabel
          control={
            <Checkbox
              data-testid={TEST_IDS.downloadUbjCheckboxLogs}
              checked={includeLogs}
              onChange={(e) => setIncludeLogs(e.target.checked)}
              size="small"
              sx={{ padding: '0 4px' }}
            />
          }
          label={t('download_ubj_include_logs')}
        />
      </Stack>

      <ModalActions>
        <Button
          data-testid={TEST_IDS.downloadUbjCancelButton}
          variant="contained"
          color="secondary"
          onClick={handleCancel}
        >
          {t('cancel')}
        </Button>
        <Button
          data-testid={TEST_IDS.downloadUbjConfirmButton}
          variant="contained"
          color="primary"
          onClick={handleConfirm}
        >
          {t('download')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
